import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { MobileNav } from "./MobileNav";

export const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="min-w-0 min-h-screen bg-[rgb(var(--bg))]">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main
        className={`min-w-0 pb-20 md:pb-0 ${
          collapsed ? "md:ml-[80px]" : "md:ml-[264px]"
        }`}
      >
        <Outlet />
      </main>
      <MobileNav />
    </div>
  );
};
